module.exports = __webpack_public_path__ + "img/living_will.47e3d2ab.png";